/* Gravur-MAX Produktseite (Webstra 10/2026): mitlaufende Kaufleiste, Header-Höhe für die mitlaufende Vorschau */
(function(){
  if(window.__wbPdp)return;window.__wbPdp=1;
  function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f);}
  function hdr(){
    var h=document.querySelector('.section-header .header-wrapper')||document.querySelector('.header-wrapper');
    var v=h?Math.round(h.getBoundingClientRect().height):64;
    document.documentElement.style.setProperty('--wb-hdr',v+'px');
  }
  ready(function(){
    hdr();window.addEventListener('resize',hdr);
    var bar=document.querySelector('[data-wb-atc]');
    var real=document.querySelector('.product-atc-btn .product-form__submit')||document.querySelector('.product-form__submit');
    if(!bar||!real)return;
    var btn=bar.querySelector('[data-wb-atc-btn]'),lab=bar.querySelector('[data-wb-atc-label]'),price=bar.querySelector('[data-wb-atc-price]');
    function fields(){
      return [].slice.call(document.querySelectorAll('.product__info-container input[required], .product__info-container textarea[required]')).filter(function(i){
        return !i.disabled && i.offsetParent!==null;
      });
    }
    function missing(){return fields().filter(function(i){return !i.value.trim();})[0]||null;}
    function sync(){
      var m=(real.textContent||'').match(/\d{1,3}(?:\.\d{3})*,\d{2}\s?€/);
      if(m&&price)price.textContent=m[0];
      if(lab)lab.textContent=missing()?'Jetzt gestalten':'In den Warenkorb';
      btn.classList.toggle('is-todo',!!missing());
    }
    var realVisible=true;
    function place(){
      var show=!realVisible && window.scrollY>500;
      bar.hidden=!show;
      document.documentElement.classList.toggle('wb-atc-on',show);
    }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){realVisible=es[0].isIntersecting;place();},{rootMargin:'0px 0px -40px 0px'}).observe(real);
    }
    window.addEventListener('scroll',function(){window.requestAnimationFrame(place);},{passive:true});
    document.addEventListener('input',sync,true);
    document.addEventListener('change',sync,true);
    document.addEventListener('click',function(){setTimeout(sync,60);},true);
    new MutationObserver(sync).observe(real,{childList:true,subtree:true,characterData:true});
    btn.addEventListener('click',function(){
      var m=missing();
      if(m){
        var y=m.getBoundingClientRect().top+window.scrollY-(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wb-hdr'))||64)-140;
        window.scrollTo({top:y,behavior:'smooth'});
        setTimeout(function(){try{m.focus({preventScroll:true});}catch(e){m.focus();}},450);
        return;
      }
      real.click();
    });
    sync();place();
  });
})();
